import React, {useRef, forwardRef, useState, useEffect, Fragment} from 'react'
// import {useDispatch, useSelector} from "react-redux"
import MaterialTable, {MTableGroupbar, MTableFilterRow} from 'material-table'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'
import {TextField} from "@material-ui/core"

// Material-UI Lab
import Autocomplete from '@material-ui/lab/Autocomplete'
import Chip from '@material-ui/core/Chip'

// Material-UI Icon
import EditIcon from '@material-ui/icons/Edit'
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import WallpaperIcon from '@material-ui/icons/Wallpaper'
import PermDataSettingIcon from '@material-ui/icons/PermDataSetting'
import GetAppIcon from '@material-ui/icons/GetApp'
import DeleteIcon from '@material-ui/icons/Delete'

// For Material-Table
import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'

// Custom Component
import useLoading from "../Loading/useLoading"
import LockScreenLoading from '../LockScreenLoading/LockScreenLoading'
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import SaveWarnDialog from '../Dialog/SaveWarnDialog'
import FullScreenDialog from '../Dialog/FullScreenDialog'
import DrawingDetail from './DrawingDetail'
import ViewDrawingForm from './ViewDrawingForm'

// Custom Style
import {whiteColor, grayColor, blueColor, nightOrangeColor, oceanBlueColor, DodgerBlueColor} from '../../styles/jss/cmsMainStyle'
import currentDrawingTableStyle from '../../styles/jss/components/drawingRegister/currentDrawingTableStyle'

// Fetch Data
import {getLatestDrawing, getPurposeType, getDrawingTypeAndGroup, downloadLatestDrawing, deleteDrawing} from '../../dataSource/drawingRegister'
import { confirmDialogStyle } from '../../styles/jss/components/dialog/confirmDialogStyle'


const useStyles = makeStyles(theme => currentDrawingTableStyle(theme))
const groupStateData = [-1, -1, -1, -1, -1, -1, -1]

const CurrentDrawingTable = props => {
	const {annotSaveChangeAction, setAnnotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()

	const tableRef = useRef()

	// Loading 
	const [getDrawingLoading, getDrawingShowLoading, getDrawingHiddenLoading] = useLoading()

	const [latestDrawing, setLatestDrawing] = useState(null)	
	const [tableData, setTableData] = useState([])
	const [tagsList, setTagsList] = useState([])
	const [purposeTypeSource, setPurposeTypeSource] = useState([])
	const [purposeTypeColumn, setPurposeTypeColumn] = useState([])
	const [drawingGroupColumn, setDrawingGroupColumn] = useState({})
	const [drawingTypeColumn, setDrawingTypeColumn] = useState([])
	const [dwgTypeGroupAndTypeSource, setDwgTypeGroupAndTypeSource] = useState([])
	const [defaultFilterKey, setDefaultFilterKey] = useState(["", "", "", "", "", "", ""])
	const [selectedDrawingRowId, setSelectedDrawingRowId] = useState(null)
	const [selectedDrawingRecord, setSelectedDrawingRecord] = useState(null)
	const [selectedDrawingEditRecord, setSelectedDrawingEditRecord] = useState(null)
	const [actionsIcon, setActionsIcon] = useState([])
	const [drawingDetailDialogOpen, setDrawingDetailDialogOpen] = useState(false)
	const [drawingEditDialogOpen, setDrawingEditDialogOpen] = useState(false)
	const [dataTableToolbarOpen, setDataTableToolbarOpen] = useState(false)
	const [drawingRefash, setDrawingRefash] = useState("")
	const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false)
	const [progressTitle, setProgressTitle] = useState("")

	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		attentionContent: "",
		confirmAction: "",
		cancelAction: ""
	})

	// Save Change Warning dialog control State
	const [saveWarnDialogOpen, setSaveWarnDialogOpen] = useState(false)
	const [saveWarnDialogData, setSaveWarnDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		saveAction: "",
		dontSaveAction: "",
		cancelAction: ""
	})


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			attentionContent: data.attentionContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}

	// Set Save Change Warning Dialog
	const buildSaveChangeWarningDialog = (data) => {
		setSaveWarnDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			saveAction: data.saveAction,
			dontSaveAction: data.dontSaveAction,
			cancelAction: data.cancelAction
		})
	}




	// Confirm Dialog Contral Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	// Confirm Save Change Dialog Control Function
	const saveChangeWarningDialogHandleOpen = (data) => {
		buildSaveChangeWarningDialog(data)
		setSaveWarnDialogOpen(true)
	}

	const saveChangeWarningDialogHandleClose = () => {
		setSaveWarnDialogOpen(false)
	}


	const renderDwgType = typeSeqKey => {
		let typeName = ""

		dwgTypeGroupAndTypeSource.map(res => {
			res.types.map(orgType => {
				if (orgType.type_seq === typeSeqKey) {
					typeName = orgType.type_name
				}
			})
		})

		return typeName
	}


	const renderDwgPurpose = purposeSeqKey => {
		let purposeRecord = ""

		purposeTypeSource.map(res => {
			if (res.purpose_seq === purposeSeqKey) {
				purposeRecord = res
			}
		})

		return purposeRecord
	}


	const CustomDwgTypeFilter = (props) => {
		// const [dwgType, setDwgType] = useState([])

		function handleChange(newImputValue) {
			const filterValue = []

			newImputValue.map(res => {
				filterValue.push(res.type_seq)
			})

			// setDwgType(filterValue)
			props.onFilterChanged(props.columnDef.tableData.id, filterValue)
		}
	  
		return (
			<Autocomplete
				multiple	
				id="dwg-type"
				// value={dwgType}
				// inputValue={inputValue}
				
				options={drawingTypeColumn}
				getOptionLabel={option => option.type_name}

				onChange={(event, newImputValue) => handleChange(newImputValue)}

				renderInput={params => (
					<TextField {...params} />
				)}
			/>
		)
	}


	const tableIcons = {
		Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
		Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
		Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
		DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
		Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
		Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
		FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
		LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
		NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
		ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
		SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
		ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
		ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
	}


	const columns = [
		{title: "Cover No", field: "cover_no", defaultGroupOrder: groupStateData[0], defaultFilter: defaultFilterKey[0]}, 
		{title: "DWG No", field: "dwg_no", defaultGroupOrder: groupStateData[1], defaultFilter: defaultFilterKey[1]},
		{title: "DWG Title", field: "dwg_title", defaultGroupOrder: groupStateData[2], defaultFilter: defaultFilterKey[2]},
		{title: "Rev.", field: "rev_no", defaultGroupOrder: groupStateData[3], defaultFilter: defaultFilterKey[3]},

		{
			title: "Purpose",
			field: "dwg_purposes",
			defaultGroupOrder: groupStateData[4],
			defaultFilter: defaultFilterKey[4],
			lookup: purposeTypeColumn,
			sorting: false,
			grouping: false,


			render: rowData => (
				rowData.dwg_purposes.map((res, index) => {
					const purposeRecord = renderDwgPurpose(res)
					return (
						<div key={index} style={{color:purposeRecord.color}}>
							{purposeRecord.name}
						</div>
					)
				})
			),
			

			customFilterAndSearch: (filterKey, rowData) => {
				let filterResult = ""

				if (filterKey.length > 0) {
					filterKey.map(keyRes => {
						if (rowData.dwg_purposes.indexOf(parseInt(keyRes)) > -1) {
							filterResult = rowData
						}
					})
				}
				else {
					return rowData
				}

				return filterResult
			}
		},

		{
			title: "DWG Type Group",
			field: "dwg_type_group",
			defaultGroupOrder: groupStateData[5],
			defaultFilter: defaultFilterKey[5],
			lookup: drawingGroupColumn,

			customFilterAndSearch: (filterKey, rowData) => {
				let filterResult = ""

				// console.log(" filterKey (dwg_type_group): ", filterKey)

				if (filterKey.length > 0) {
					filterKey.map(keyRes => {
						if (rowData.dwg_type_group === parseInt(keyRes)) {
							filterResult = rowData
						}
					})
				}
				else {
					return rowData
				}

				return filterResult
			}

			// filterComponent: props => {
			// 	return (
			// 		<Autocomplete
			// 			id="dwg-type-group"

			// 			value={dwgTypeGroupFilterKey}
			// 			// inputValue={inputValue}

			// 			options={dwgTypeGroupAndTypeSource}
			// 			getOptionSelected={option => option.type_group_seq}
			// 			getOptionLabel={option => option.type_group_name}

			// 			onChange={(event, newValue) => {
			// 				setDwgTypeSource([])
			// 				setDwgTypeGroupFilterKey(newValue)
			// 				setDwgTypeFilterKey()
			// 				dwgTypeGroupFilter(newValue)

			// 				dwgTypeGroupAndTypeSource.map(res => {
			// 					if (res.type_group_seq === newValue.type_group_seq) {
			// 						setDwgTypeSource(res.types)
			// 					}
			// 				})

			// 			}}

			// 			// onInputChange={(event, newInputValue) => {
			// 			// 	setInputValue(newInputValue)
			// 			// 	dwgTypeGroupFilter(newInputValue)
			// 			// }}



			// 			renderInput={params => {
			// 				return (
			// 					<TextField
			// 						{...params}
			// 						// variant="outlined"
			// 						label={props.value}
			// 						fullWidth
			// 					/>
			// 				)
			// 			}}


			// 			//renderInput={params => <TextField {...params} />}
			// 		/>
			// 	)
			// },
		},

		{
			title: "DWG Type",
			field: "dwg_types",
			defaultGroupOrder: groupStateData[6],
			defaultFilter: defaultFilterKey[6],
			sorting: false,
			grouping: false,

			render: rowData => (
				rowData.dwg_types.map((res, index) => 
					<div key={index}>
						{renderDwgType(res)}
					</div>
				)
			),

			customFilterAndSearch: (filterKey, rowData) => {
				let filterResult = ""

				if (filterKey.length > 0) {
					filterKey.map(keyRes => {
						if (rowData.dwg_types.indexOf(parseInt(keyRes)) > -1) {
							filterResult = rowData
						}
					})
				}
				else {
					return rowData
				}

				return filterResult
			},
			
			filterComponent: props => <CustomDwgTypeFilter {...props} />
		},
	]


	const groupingState = rowData => {
		rowData.map((res, index) => {
			groupStateData[res.tableData.id] = index
		})
	}

	const unGroupingState = rowData => {
		groupStateData[rowData.tableData.id] = -1
	}

	const buildTagsList = data => {
		let listResult = []
		
		data.map(row => {
			row.dwg_tags.map(tagRec => {
				listResult.push({
					name: tagRec
				})
			})
		})

		return [...new Map(listResult.map(item => [item.name, item])).values()]
	}


	// Custom Filter to filter the Tags field
	const tagsFilter = filterKey => {
		let tagsFilterResult = []

		if (filterKey.length > 0) {
			filterKey.map(key => {
				latestDrawing.map(item => {
					item.dwg_tags.map(tag => {
						if (tag.toLowerCase() == key.name.toLowerCase()) {
							tagsFilterResult.push(item)
						}
					})

					// setTableData([...new Map(tagsFilterResult.map(item => [item.dwgNo, item])).values()])
					setTableData(tagsFilterResult)
				})
			})
		}
		else {
			setTableData(latestDrawing)
		}
	}



	// const dwgTypeGroupFilter = key => {
	// 	let dataResult = []

	// 	// console.log("*** key : ", key)

	// 	if (key) {
	// 		latestDrawing.map(item => {
	// 			if (item.dwg_type_group_name.toLowerCase() === key.type_group_name.toLowerCase()) {
	// 				dataResult.push(item)
	// 			}
	// 			setTableData(dataResult)
	// 		})
	// 	}
	// 	else {
	// 		setTableData(latestDrawing)
	// 	}
	// }


	// const dwgTypeFilter = key => {
	// 	let dataResult = []

	// 	console.log("*** key : ", key)

	// 	if (key) {
	// 		latestDrawing.map(dwgItem => {
	// 			key.every(keyItem => {
	// 				if (dwgItem.dwg_types.includes(keyItem.type_seq)) {
	// 					dataResult.push(dwgItem)
	// 				}
	// 			})
	// 		})

	// 		setTableData(dataResult)
	// 	}
	// }



	// Dialog open and close central
	const drawingDetailDialogHandleOpen = () => {
		setDrawingDetailDialogOpen(true)
	}

	const drawingDetailDialogHandleClose = () => {
		if (!store.get('annotActive')) {
			setDrawingDetailDialogOpen(false)
		}
		else {
			saveChangeWarningAction()
		}
	}


	const drawingEditDialogHandleOpen = (selectedRecord) => {
		setSelectedDrawingEditRecord(selectedRecord[0])
		setDrawingEditDialogOpen(true)
	}

	const drawingEditDialogHandleClose = () => {
		setDrawingEditDialogOpen(false)
	}


	// Action
	const saveChangeWarningAction = () => {
		saveChangeWarningDialogHandleOpen({
			dialogTitle: "Annotation Change Warning",
			dialogContent: "Do you want to save the change of annotation.",
			saveAction: saveChangeWarningSaveAnnotation,
			dontSaveAction: saveChangeWarningDontSaveAnnotation,
			cancelAction: saveChangeWarningCancelAction
		})
	}

	const saveChangeWarningSaveAnnotation = () => {
		saveChangeWarningCancelAction()

		annotSaveChangeAction().then(() => {
			setDrawingDetailDialogOpen(false)
			store.set('annotActive', false)
		})
	}

	const saveChangeWarningDontSaveAnnotation = () => {
		saveChangeWarningCancelAction()
		setDrawingDetailDialogOpen(false)
		store.set('annotActive', false)
	}

	const saveChangeWarningCancelAction = () => {
		saveChangeWarningDialogHandleClose()
	}


	// Dialog button declaration
	const drawingDetailDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]

	const drawingEditDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]


	const purposeTypeConvert = source => {
		const result = {}

		if (source) {
			source.map(res => {
				result[res.purpose_seq] = res.name
			})
		}

		return result
	}


	const drawingGroupConvert = source => {
		const result ={}

		if (source) {
			source.map(res => {
				result[res.type_group_seq] = res.type_group_name
			})
		}

		return result
	}


	// const drawingTypeConvert = source => {
	// 	const result ={}

	// 	if (source) {
	// 		source.map(res => {
	// 			res.types.map(type => {
	// 				result[type.type_seq] = res.type_group_name + ": " + type.type_name
	// 			})
				
	// 		})
	// 	}

	// 	return result
	// }

	const drawingTypeConvert = source => {
		const result = []

		if (source) {
			source.map(res => {
				res.types.map(type => {
					result.push({
						type_seq: type.type_seq,
						type_name: type.type_name
					})
				})
			})
		}

		return result
	}


	const downloadLatestDrawingAction = (selectedRow, fullset) => {
		const dwgSeq = []

		setProgressTitle("Downloading...")
		setLockScreenLoadingOpen(true)

		selectedRow.map(res => {
			dwgSeq.push(res.dwg_seq)
		})

		downloadLatestDrawing(dwgSeq, fullset).then(() => {
			console.log("Latest Drawing Download Successful")

			tableRef.current.onAllSelected(false)
			setLockScreenLoadingOpen(false)
			setProgressTitle("")
		})
	}


	const removeDrawingConfirmAction = (selectedRow) => {
		confirmDialogHandleOpen({
			dialogTitle: "Remove Drawing",
			dialogContent: "Are you sure to remove drawing.",
			attentionContent: "Under this drawing, all record will be remove together. Include revision record and all related items record",
			confirmAction: () => removeDrawingAction(selectedRow),
			cancelAction: removeDrawingCancelAction
		})
	}

	const removeDrawingAction = (selectedRow) => {
		confirmDialogHandleClose()

		selectedRow.map(rowRes => {
			deleteDrawing(rowRes.dwg_seq).then(res => {
				setDrawingRefash(res.code)

				buildAlert({
					// Alert Type: success, info, warning, error
					type: "success",
					title: "Success Alert",
					content: "The drawing have been removed"
				})
			})
		})
	}

	const removeDrawingCancelAction = () => {
		confirmDialogHandleClose()
	}


	useEffect(() => {
		getDrawingShowLoading()

		getPurposeType().then(res => {
			setPurposeTypeSource(res)
			setPurposeTypeColumn(purposeTypeConvert(res))
		})

		getDrawingTypeAndGroup().then(res => {
			setDwgTypeGroupAndTypeSource(res)
			setDrawingGroupColumn(drawingGroupConvert(res))
			setDrawingTypeColumn(drawingTypeConvert(res))
		})

		getLatestDrawing().then(res => {
			setLatestDrawing(res.data)
			setTableData(res.data)
			setTagsList(buildTagsList(res.data))

			getDrawingHiddenLoading()
		})
	}, [drawingRefash])


	return (
		// console.log("Table Data | Variable: tableData (CurrentDrawingTable.js)"),
		// console.log(tableData),

		// console.log("Tags List for AutoComplete | Variable: tagsList (CurrentDrawingTable.js)"),
		// console.log(tagsList),

		// console.log("Purpose Type | Variable: purposeTypeSource (CurrentDrawingTable.js)"),
		// console.log(purposeTypeSource),

		// console.log("Drawing Type and Group | Variable: dwgTypeGroupAndTypeSource (CurrentDrawingTable.js)"),
		// console.log(dwgTypeGroupAndTypeSource),

		// console.log("Drawing Type Group for lookup | Variable: drawingGroupColumn (CurrentDrawingTable.js)"),
		// console.log(drawingGroupColumn),

		// console.log("Drawing Type Group for lookup | Variable: drawingTypeColumn (CurrentDrawingTable.js)"),
		// console.log(drawingTypeColumn),

		// console.log("Default Filter Value | Variable: defaultFilterKey (CurrentDrawingTable.js)"),
		// console.log(defaultFilterKey),

		// console.log("Group Status Data | Variable: groupStateData (CurrentDrawingTable.js)"),
		// console.log(groupStateData),

		// console.log("---------------------------------------------------------------------------------"),

		<Fragment>
			<div>
				<LockScreenLoading 
					open={lockScreenLoadingOpen}
					circleSize={200}
					progressTitle={progressTitle}
				/>

				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					attentionContent={confirmDialogData.attentionContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				<SaveWarnDialog
					open={saveWarnDialogOpen}
					dialogTitle={saveWarnDialogData.dialogTitle}
					dialogContent={saveWarnDialogData.dialogContent}
					saveAction={saveWarnDialogData.saveAction}
					dontSaveAction={saveWarnDialogData.dontSaveAction}
					cancelAction={saveWarnDialogData.cancelAction}
				/>

				<FullScreenDialog
					open={drawingDetailDialogOpen}
					dialogTitle={"Change Management"}

					formContent={
						<DrawingDetail
							selectedDrawing={selectedDrawingRecord}
							annotSaveChangeAction={annotSaveChangeAction}
							setAnnotSaveChangeAction={setAnnotSaveChangeAction}
						/>
					}

					button={drawingDetailDialogBtn}
					handleClose={drawingDetailDialogHandleClose}
				/>

				<FullScreenDialog
					open={drawingEditDialogOpen}
					dialogTitle={"Drawing property modification"}

					formContent={
						<ViewDrawingForm
							selectedDrawing={selectedDrawingEditRecord}
							setDrawingRefash={setDrawingRefash}
						/>
					}

					button={drawingEditDialogBtn}
					handleClose={drawingEditDialogHandleClose}
				/>
			</div>

			{getDrawingLoading}
			<div>
				<Autocomplete
					multiple
					id="tags-filter"
					options={tagsList}
					getOptionLabel={(option) => option.name}
					// defaultValue={""}
					// filterSelectedOptions

					onChange={(event, value) => {
						tagsFilter(value)
					}}

					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							label="Tags Filter"
							// placeholder="Favorites"
						/>
					)}
				/>
			</div>


			<MaterialTable
				tableRef={tableRef}
				icons={tableIcons}
				title=""
				columns={columns}
				data={tableData}

				detailPanel={[
					{
						tooltip: 'Show Tags',
						render: rowData => {
							return (
								<div
									style={{
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 100,
										paddingRight: 20,
										fontSize: 15,
										textAlign: 'left',
										color: 'blue',
										backgroundColor: nightOrangeColor[0],
									}}
								>
									{
										rowData.dwg_tags.map((x, index) => {
											return (
												<Chip
													style={{paddingLeft: 5, paddingRight: 5, paddingTop: 5, paddingBottom: 5, marginRight: 10}}
													key={index}
													variant="outlined"
													size="small"
													icon={<LocalOfferIcon />}
													label={x}
													color="primary"
												/>
											)
										})
									}
								</div>
							)
						},
					},
				]}

				actions={actionsIcon}


				// components={{
				//     Body: props => <MTableBody {...props} onFilterChanged={(columnId, value, field) => {
				//         props.onFilterChanged(columnId, value)
				//         // filterRef.current = value
						
				// 		console.log("field : ", props)

				//     }} />
				// }}

				// components={customFilter}


				// components={{
				// 	Toolbar: props => (
				// 		<div>
				// 			<MTableToolbar {...props} />
				// 			<div style={{ padding: "0px 10px", textAlign: "left" }}>
							
				// 				<TextField
				// 					label="Tags Search"
				// 					value={filter}
				// 					onChange={event => {
										
				// 						console.log("event.target.value", event.target.value)
				// 						setFilter(event.target.value)
				// 					}}
				// 				/>

				// 			</div>
				// 		</div>
				// 	)
				// }}


				// onFilterChange={(filters) => {
				// 	console.log('onFilterChange', filters)
				// 	const tempKey = [...defaultFilterKey]

				// 	filters.map(res => {
				// 		tempKey[res.column.tableData.columnOrder] = res.column.tableData.filterValue
				// 	})

				// 	setDefaultFilterKey(tempKey)
				// }}


				// onSearchChange={handleSearchChange}
				// onFilterChange={handleFilterChange}

				// onToggleDetailPanel={() => {
				// 	alert("toggle")
				// }}


				// onGroupExpandChanged={() => {
				// 	alert("aaa")
				// }}


				// onColumnDragged={data => {
				// 	console.log("column drag data: ", data)
				// }}


				onGroupRemoved={(groupedColumn, index) => {
					console.log("Grouped Column: ", groupedColumn)
					console.log("Grouped Index: ", index)

					unGroupingState(groupedColumn)
				}}


				onSelectionChange={(data) => {
					console.log("select data (current drawing): ", data)

					if (data.length > 0) {
						if (data.length === 1) {
							setActionsIcon(
								[
									{
										icon: () => <EditIcon color="primary"/>,
										tooltip: 'Edit',
										onClick: (event, rowData) => {
											drawingEditDialogHandleOpen(rowData)
										}
									},

									{
										icon: () => <PermDataSettingIcon />,
										tooltip: "Upload Drawing to BIM360",
										onClick: (event, rowData) => {
											console.log("Press Upload Drawing to BIM360: ", rowData)
										}
									},

									{
										icon: () => <WallpaperIcon />,
										tooltip: "Upload Drawing to PlanGrid",
										onClick: (event, rowData) => {
											console.log("Press Upload Drawing to PlanGrid: ", rowData)
										}
									},
	
									{
										icon: () => <GetAppIcon color="primary"/>,
										tooltip: "Download Latest Drawing",
										onClick: (event, rowData) => {
											downloadLatestDrawingAction(rowData, false)
										}
									},
	
									{
										icon: () => <DeleteIcon color="primary"/>,
										tooltip: 'Delete',
										onClick: (event, rowData) => {
											removeDrawingConfirmAction(rowData)
										}
									}
								]
							)
						}
						else {
							setActionsIcon(
								[
									{
										icon: () => <PermDataSettingIcon />,
										tooltip: "Upload Drawing to BIM360",
										onClick: (event, rowData) => {
											console.log("Press Upload Drawing to BIM360: ", rowData)
										}
									},

									{
										icon: () => <WallpaperIcon />,
										tooltip: "Upload Drawing to PlanGrid",
										onClick: (event, rowData) => {
											console.log("Press Upload Drawing to PlanGrid: ", rowData)
										}									},

									{
										icon: () => <GetAppIcon color="primary"/>,
										tooltip: "Download Latest Drawing",
										onClick: (event, rowData) => {
											downloadLatestDrawingAction(rowData, false)
										}
									},
	
									{
										icon: () => <DeleteIcon color="primary"/>,
										tooltip: 'Delete',
										onClick: (event, rowData) => {
											removeDrawingConfirmAction(rowData)
										}
									}
								]
							)
						}

						setDataTableToolbarOpen(true)
					}
					else {
						setDataTableToolbarOpen(false)
					}
				}}
				
					
				onRowClick={(event, selectedDrawing) => {
					setSelectedDrawingRowId(selectedDrawing.tableData.id)
					setSelectedDrawingRecord(selectedDrawing)

					drawingDetailDialogHandleOpen()
				}}

				// components={{
				// 	column: props => (

				// 		<MTableBodyRow {...props}
				// 			draggable="true"
				// 			onDragStart={(e) => {
				// 				console.log('onDragStart')
				// 				// DrageState.row = props.data.tableData.id

				// 			}}

				// 			onDragEnter={e => {
				// 				e.preventDefault()
				// 				console.log('onDragEnter')
				// 				// if( props.data.tableData.id != DrageState.row){
				// 				// 	DrageState.dropIndex = props.data.tableData.id 

				// 				// }                                                  
				// 			}}

				// 			onDragEnd={(e) => {
				// 				console.log(`onDragEnd`)

				// 				// if(DrageState.dropIndex != -1){
				// 				// 	reodering({index: DrageState.row, dropIndex: DrageState.dropIndex})
				// 				// }
				// 				// DrageState.row = -1
				// 				// DrageState.dropIndex = -1

				// 			}}
				// 		/>

				// 	)
				// }}


				components={{
					Groupbar: props => {
						groupingState(props.groupColumns)

						return (
							<div>
								<MTableGroupbar classes={{root:"some_class"}} {...props} />
							</div>
						)
					},

					FilterRow: props => {
						return (
							<MTableFilterRow {...props} />
						)
					}
				}}

				localization={{
					header : {
						actions: ""
					},

					grouping: {
						groupedBy: ""
					}
				}}

				options={{
					showTitle: false,
					toolbar: dataTableToolbarOpen,
					sorting: true,
					grouping: true,
					paging: false,
					selection: true,
					search: false,
					filtering: true,
					draggable: true,

					minBodyHeight: "100px",
					maxBodyHeight: "630px",

					headerStyle: {
						backgroundColor: oceanBlueColor[10],
						fontFamily: "Gill Sans, sans-serif",
						fontWeight: "bold",
						fontSize: "16px",
						// color: grayColor[8],
						color: whiteColor,
					},

					rowStyle: rowData => ({
						backgroundColor: selectedDrawingRowId === rowData.tableData.id ? oceanBlueColor[0] : "",
						fontSize: "14px",
						fontFamily: "Gill Sans, sans-serif",
					}),

					// cellStyle: { 
					// 		// backgroundColor: '#039be5',
					// 	fontFamily: "Gill Sans, sans-serif",
					// 		// color: '#FFF',
					// 		// height: 200,
					// 		// maxHeight: 200
					// 	}
				}}
			/>
		</Fragment>
	)
}


export default CurrentDrawingTable